import { Injectable, inject } from "@angular/core";
import type { DashDTO } from "@magpie/types";
import type { CreateDashInput, UpdateDashInput } from "@magpie/edge";
import { TrpcService } from "./trpc.service";

@Injectable({
	providedIn: "root",
})
export class DashService {
	private readonly trpc = inject(TrpcService);

	async getDashes(): Promise<DashDTO[]> {
		return this.trpc.client.dash.list.query();
	}

	async getDashById(id: string): Promise<DashDTO> {
		return this.trpc.client.dash.getById.query({ id });
	}

	async create(payload: CreateDashInput): Promise<DashDTO> {
		return this.trpc.client.dash.create.mutate(payload);
	}

	async update(
		id: string | null,
		payload: UpdateDashInput | CreateDashInput,
	): Promise<DashDTO> {
		if (!id) {
			return this.create(payload as CreateDashInput);
		}
		return this.trpc.client.dash.update.mutate({ id, data: payload });
	}
}
